import React from 'react';
import classnames from 'classnames';
import { Input, InputProps, ChangeContext } from 'tea-component';
import { isValidNumber, vaildNum } from '@gp/utils/common';

interface IDecimalsCfg {
  // 是否支持小数，默认不支持
  supportedDecimals?: boolean;
  // 小数位数，默认为2位小数
  decimalsLength?: number;
}

export interface INumberInputProps extends Omit<InputProps, 'onChange'>, IDecimalsCfg {
  onChange?: (value: string, context?: ChangeContext) => void;
}

const formatNumberValue = (value: string, params?: IDecimalsCfg): string => {
  const { supportedDecimals = false, decimalsLength = 2 } = params || {};
  let validValue = value ? vaildNum(value) : '';
  // 不支持小数，或小数位数非法时，去掉小数部分
  if (!supportedDecimals || !(decimalsLength >= 1)) {
    validValue = validValue?.replace(/\.\d*$/, '');
  } else if (validValue?.includes('.')) {
    // 有小数，保留正确的小数位数
    validValue = validValue?.replace(new RegExp(`^(\\d+)(\\.)(\\d{1,${decimalsLength}})(\\d*)$`), '$1$2$3');
  }
  return validValue;
};

const NumberInput: React.FC<INumberInputProps> = (props) => {
  const {
    style,
    className,
    placeholder = 'Please input',
    supportedDecimals,
    decimalsLength,
    value,
    onChange,
    ...restProps
  } = props;

  return (
    <Input
      {...restProps}
      style={style}
      className={classnames('dbg-common-number-input', className)}
      placeholder={placeholder}
      value={isValidNumber(value) ? value : ''}
      onChange={(value, context) => {
        const validValue = formatNumberValue(value, { supportedDecimals, decimalsLength });
        onChange?.(validValue, context);
      }}
      onBlur={() => {
        const validValue = (!value?.endsWith('.') ? value : value?.substring(0, value?.length - 1)) || '';
        onChange?.(validValue);
      }}
    />
  );
};

export default NumberInput;
